import cls from "classnames";

import TagAndPerks from "./TagAndPerks";
import MemberCountDisplayLabel from "./MemberCountDisplayLabel";
import UserAvatar from "@qoohoo/common/components/UserAvatar";

const Description = ({ channelDetails, scrollToCreator, customConfig }) => {
  const totalMembers = channelDetails.total_number_of_subscribers;

  const showHeartIcon = totalMembers > 0;

  const hideMembers = channelDetails.hide_members ?? false;

  const showMembers = !hideMembers;

  function getEmoticon(tag) {
    let emoticon = null;

    if (tag?.emoji_unicode) {
      emoticon = (
        <span className="text-[18px] leading-[18px]">{tag.emoji_unicode}</span>
      );
    } else if (tag?.media?.url) {
      emoticon = (
        <img src={tag.media.url} alt="category icon" className="max-h-5" />
      );
    }

    return emoticon;
  }

  return (
    <div className={cls({ "md:mt-10": channelDetails.medias.length !== 0 })}>
      <div className="w-24 h-24 sm:w-[140px] sm:h-[140px] mb-5 overflow-hidden sm:mb-8 md:hidden rounded-2xl">
        <div className="w-full h-full bg-center text-4xl font-bold flex justify-center items-center uppercase bg-[#2E353A]">
          <UserAvatar
            avatarUrl={channelDetails.center_image?.url}
            alt={channelDetails.name}
            userName={channelDetails.name}
          />
        </div>
      </div>
      <h1 className="text-2xl font-bold md:text-[40px] font-inter !leading-[1.4]">
        {channelDetails.name}
      </h1>
      <div
        className="font-nunito cursor-pointer truncate md:hidden mt-4"
        onClick={scrollToCreator}
      >
        by {channelDetails.creator.fullname || channelDetails.creator.username}
      </div>
      <div className="flex flex-row items-center justify-between space-x-8 w-full mt-4 sm:mt-6 max-w-[578px] text-[#F0F0F0] text-sm sm:text-base">
        {channelDetails.category?.length > 0 &&
          channelDetails.category.map((tag, index) => {
            return (
              <div
                key={index}
                className="flex flex-row items-center px-4 py-1.5 text-xs md:text-sm rounded-full md:px-3 w-max bg-[#2D3339] md:py-2 font-inter md:mt-0"
              >
                {getEmoticon(tag)}
                <span className="mx-2">{tag?.display_name}</span>
              </div>
            );
          })}
        {showMembers && (
          <div className="flex flex-row items-center min-w-max">
            {showHeartIcon && (
              <img
                src="/assets/icons/user-heart.svg"
                alt="Total people joined"
                className="w-5 h-5 sm:w-6 sm:h-6"
              />
            )}
            <MemberCountDisplayLabel totalMembers={totalMembers} />
          </div>
        )}
      </div>
      <div className="md:hidden">
        <TagAndPerks channelDetails={channelDetails} />
      </div>
    </div>
  );
};

export default Description;
